import { render, staticRenderFns } from "./PublicHome.vue?vue&type=template&id=21ea8ff1&scoped=true"
import script from "./PublicHome.vue?vue&type=script&lang=js"
export * from "./PublicHome.vue?vue&type=script&lang=js"
import style0 from "./PublicHome.vue?vue&type=style&index=0&id=21ea8ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea8ff1",
  null
  
)

export default component.exports